import React, { HTMLProps } from 'react'
import { UseFormRegister } from 'react-hook-form'
import { twMerge } from 'tailwind-merge'

export enum InputType {
  INPUT,
  SELECT,
  TEXT_AREA,
}

export interface Option {
  id: string
  value: string
}

interface InputProps extends HTMLProps<HTMLInputElement> {
  label: string
  inputType?: InputType
  options?: Option[]
  register: UseFormRegister<any>
  required?: boolean
  errorMessage?: string
  validationPattern?: RegExp
}

const Input = ({
    label,
    className,
    options,
    inputType = InputType.INPUT,
    register,
    required = false,
    name,
    errorMessage,
    validationPattern,
    ...props
}: InputProps) => {
    const classes = twMerge(
        'transition border border-black/20 px-3 py-1 w-full h-[50px] placeholder:text-xs outline-0 focus:border-2 focus:border-purple',
        errorMessage && 'border-2 border-red bg-red-light',
    )

    const renderInput = () => {
        switch (inputType) {
        case InputType.INPUT:
        default:
            return (
                <input
                    {...props}
                    className={classes}
                    {...register(name as string, { required, pattern: validationPattern })}
                />
            )
        case InputType.SELECT:
            return (
                <select
                    className={classes}
                    {...register(name as string, { required, pattern: validationPattern })}
                >
                    <option> Select </option>
                    {options?.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.value}
                        </option>
                    ))}
                </select>
            )
        case InputType.TEXT_AREA:
            return (
            // @ts-ignore
                <textarea
                    {...props}
                    className={twMerge(classes, 'resize-none h-[160px]')}
                    {...register(name as string, { required, pattern: validationPattern })}
                />
            )
        }
    }
    return (
        <div className={className}>
            <h6 className='mb-1'>{label}:</h6>
            {renderInput()}
            {errorMessage && <p className='text-sm text-red mt-1'>{errorMessage}</p>}
        </div>
    )
}

export default Input
